import Pararax from './pararax';
import Contents from './contents';



export default class smoothScrollManager{
    constructor(pageID){

        this.w = window.innerWidth;
        this.h = window.innerHeight;
        this.fpsRate;
        this.pageID = pageID;

        this.$bodyTag;
        this.$root;
        this.$container;
        this.$body;


        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";

        this.paraPoint = [];

        this.scrollLimit = 0; // scroll limit

        this.timer = [];

        this.type = "normal";

        this.inertia = (Useragnt.ie||Useragnt.safari||Useragnt.mobile||Useragnt.tablet||this.pageID=='contact')?false:true; /* 慣性スクロールを有効にするか */

        this.pararax;
        this.contents;
        this.bodyHeight

        /* 状態監視用のフラグ */
        this.status = {
            comp     : false, /* 慣性スクロールが完了したか */
            deviceSize : "",
            exResizeMode : false,
        }

    }
    init(pageID){

        this.pageID = pageID;
        this.$bodyTag = document.getElementsByTagName('body');
        this.$root = document.getElementById("l-root");
        this.$container = document.getElementById("l-scroll");
        this.$body = document.getElementById("l-scroll-body");

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.dir = "next";
        this.add = 0.05;

        if(!this.inertia) this.$bodyTag[0].classList.add('is-inertia-none');



        this.pararax = new Pararax();
        this.pararax.init();
        this.contents = new Contents(this);
        this.contents.init(pageID);

        // document.getElementById("l-pagetop").addEventListener("click",()=>{
        //     this.to(0);
        // });
        document.querySelector(".scroll-top-footer").addEventListener("click",(e)=>{
            e.stopPropagation();
            TweenLite.to(window, 0.1, {scrollTo:{y:0,autoKill:false},onComplete:()=>{
                    // this.status.off = false;
                }});
        });

    }
    to(inc){
        TweenMax.killTweensOf(window,{scrollTo:true});
        TweenLite.to(window, !this.inertia?0.5:0.1, {scrollTo:{y:inc,autoKill:false},onComplete:()=>{
                // this.status.off = false;
                setTimeout(()=>{
                    this.contents.scroll(this.nowInc,this.dir)
                },1e3);
            }});
    }
    selectTo(id) {
        if (document.getElementById(id)) {

            const _$h = window.innerWidth<=750 ? document.querySelector('.header-inner-sp') : document.querySelector('.header-inner-pc')

            const _posi =
                document.getElementById(id).getBoundingClientRect().top -
                _$h.clientHeight +
                this.inc
            this.to(_posi)
        }
    }
    reset(){
        this.to(0);
        this.update(0,"prev");
        this.nowInc = 0;
        this.add = 1; // 一瞬イージングなし
        this.trans();
        this.add = 0.05; // イージング戻す
    }
    loadUpdate(){
        if(!this.inertia) this.$bodyTag[0].classList.add('is-inertia-none');
        // this.reset();
    }
    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */

        this.inc = inc;
        this.dir = (dir==="")?(this.inc>this.prevInc)?"next":"prev":dir;
        // this.prevInc = this.inc;
        this.mode = "scroll";

        // if(Useragnt.ie&&this.status.comp){
        //     console.log("resize!!!")
        //     this.resize();
        // }

        this.status.comp = false;
    }
    move(fpsRate,mouse) {

        // if(this.status.comp||inc==undefined) return;
        if(this.inc==undefined||this.status.comp) return;

        this.nowInc += (this.add * (this.inc - this.nowInc))*fpsRate;

        if(this.inertia){
            // console.log("scroll",this.nowInc)
            TweenLite.set(this.$body,{y:-this.nowInc})
            // this.$body.style.transform = 'translateY(-'+ this.nowInc +'px)'
        }
        /* スクロール連動で動作 */
        this.pararax.mot(this.nowInc,1);
        this.contents.scroll(this.nowInc,this.dir)
        this.contents.mot(this.nowInc,mouse,this.status.comp)
        if(
            this.prevInc>this.nowInc-0.1&&this.dir=="next" ||
            this.prevInc<this.nowInc+0.1&&this.dir=="prev"
        ){
            this.onComplete();
        }
        this.prevInc = this.nowInc;


    }

    resize (w,h) {

        if (this.status.exResizeMode){

            this.exResize(h,false)

            return
        }

        this.w = w;
        this.h = h;

        this.bodyHeight = this.$body.clientHeight

        if(Useragnt.pc){
            TweenMax.set(this.$root,{"height":this.$body.clientHeight});
        }else{
            TweenMax.set(this.$root,{"height":"auto"});
        }


        this.pararax.resize(h)
        this.contents.resize(h,this.$body.clientHeight,this.inc)

    }
    exResize(h, off) {
        //他のjsから指定した高さに変更させる

        if (off) {
            this.status.exResizeMode = false;
            this.resize(window.innerWidth,window.innerHeight)
            TweenMax.set(this.$root, { height: this.$body.clientHeight })
            TweenMax.set(this.$root, { position: '', top: '', left: '' })
        } else {
            this.status.exResizeMode = true;
            TweenMax.set(this.$root, { height: h })
            TweenMax.set(this.$root, { position: 'fixed', top: 0, left: 0 })
        }
    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        this.status.comp = true;
        // this.nowInc = this.inc;
        // this.move(this.fpsRate)
    }

    /* -------------------------------------------

      -- ステータスいじいじするやつ

    ------------------------------------------- */

    datGUI(){

    }
}